module.exports = __webpack_public_path__ + "img/29.51d4be69.jpg";